import store from '@/store'

export function bumen(bean) {
  return [
    bean.jiagou_first_name,
    bean.jiagou_second_name,
    bean.jiagou_third_name,
    bean.jiagou_forth_name
  ]
    .filter(x => x)
    .join('/')
}

export function datetime(date, format = 'yyyy-MM-dd HH:mm:ss') {
  if (!date) {
    return ''
  }
  if (typeof date === 'string') {
    date = new Date(date)
  }
  typeof date === 'number' && (date = new Date(date))
  let obj = {
    // yyyy-MM-dd 第q季度 www HH:mm:ss:SSS
    y: date.getFullYear(),
    M: date.getMonth() + 1,
    d: date.getDate(),
    q: Math.floor((date.getMonth() + 3) / 3),
    w: date.getDay(),
    H: date.getHours(),
    h: date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
    m: date.getMinutes(),
    s: date.getSeconds(),
    S: date.getMilliseconds()
  }
  let _week = ['日', '一', '二', '三', '四', '五', '六']
  for (let i in obj) {
    format = format.replace(new RegExp(i + '+', 'g'), m => {
      let val = obj[i] + ''
      if (i === 'w') return (m.length > 2 ? '星期' : '周') + _week[val]
      for (let j = 0, len = val.length; j < m.length - len; j++) {
        val = '0' + val
      }
      return m.length === 1 ? val : val.substring(val.length - m.length)
    })
  }
  return format
}

export function convertChannel(item) {
  const first = store.state.global.channels.find(x => +x.id === +item.first)
  if (first) {
    const second = first.children && first.children.length ? first.children.find(x => +x.id === +item.second) : ''
    return second ? `${first.label}/${second.label}` : first.label
  } else {
    return ''
  }
}

export function convertChannelDesc(item) {
  const first = store.state.global.channels.find(x => +x.id === +item.first)
  if (first) {
    const second = first.children.find(x => +x.id === +item.second)
    return second ? second.description : ''
  } else {
    return ''
  }
}

export function convertMenu(value) {
  const menu = store.state.enums.menu.find(x => x.value === value)
  return menu ? menu.label : value
}
